import { Deserializable } from '../deserializable';

export class UserTradingBankAccount implements Deserializable {
  public balance: number;
  public balanceDate: Date;
  public accountNumber: number;
  public cifNumber: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
